import { Injectable, signal } from '@angular/core';

export type ToastType = 'success' | 'error' | 'warning' | 'info';

export interface Toast {
  id: number;
  message: string;
  type: ToastType;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private nextId = 0;
  private readonly _toasts = signal<Toast[]>([]);
  readonly toasts = this._toasts.asReadonly();

  show(message: string, type: ToastType = 'info', durationMs = 5000): void {
    const id = this.nextId++;
    this._toasts.update(t => [...t, { id, message, type }]);

    setTimeout(() => this.dismiss(id), durationMs);
  }

  error(message: string, durationMs = 10000): void {
    this.show(message, 'error', durationMs);
  }

  success(message: string, durationMs = 5000): void {
    this.show(message, 'success', durationMs);
  }

  dismiss(id: number): void {
    this._toasts.update(t => t.filter(toast => toast.id !== id));
  }
}
